import React from "react";
import Router from "Components/Router";
import GlobalStyles from "styles/GlobalStyles";

const App = () => (
  <>
    <GlobalStyles />
    <Router />
  </>
);

export default App;
